import { EntityTemplateField } from "../../../entityTemplates/EntityTemplate.types.ts";

/** A renewal period extends the end date, so a contract without one has nothing for it to extend. */
export function isAutoRenewalShown(endDateField: EntityTemplateField, endDate: Date | undefined | null): boolean {
    return endDateField.configurationData?.value === "true" && endDate !== undefined && endDate !== null;
}
